import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/** @extends {Component<{ link: HTMLAnchorElement }>} */
class ProductPersonalization extends Component {
  requiredRefs = ['link'];
  #controller;
  #generation = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.updateVariant, { signal });
    this.addEventListener('click', (event) => {
      if (this.refs.link.getAttribute('aria-disabled') === 'true') event.preventDefault();
    }, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#generation++;
  }

  /** @param {import('@shopify/events').ProductSelectEvent} event */
  updateVariant = async (event) => {
    if (event.target instanceof Element && event.target.closest('product-card')) return;
    const generation = ++this.#generation;
    this.refs.link.setAttribute('aria-disabled', 'true');
    this.refs.link.setAttribute('aria-busy', 'true');
    try {
      const { detail } = await event.promise;
      if (generation !== this.#generation || !this.isConnected) return;
      const next = detail?.html?.querySelector(
        `product-personalization[data-product-id="${CSS.escape(this.dataset.productId || '')}"] [ref="link"]`
      );
      if (!(next instanceof HTMLAnchorElement)) return;
      const link = this.refs.link;
      link.href = next.href;
      link.replaceChildren(...Array.from(next.childNodes, (node) => node.cloneNode(true)));
      for (const attribute of ['aria-disabled', 'tabindex']) {
        if (next.hasAttribute(attribute)) link.setAttribute(attribute, next.getAttribute(attribute));
        else link.removeAttribute(attribute);
      }
    } catch {
      // Keep the link disabled until a variant is resolved successfully.
    } finally {
      if (generation === this.#generation && this.isConnected) this.refs.link.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('product-personalization')) {
  customElements.define('product-personalization', ProductPersonalization);
}
